// This is a temporary tool which will only allow for english to spanish phrases which are hard coded in.
const translateFromEnglish = (englishPhrase, translatedPhrase, translate) => {
  if (translate) {
    return translatedPhrase
  }
  return englishPhrase
}

export default translateFromEnglish
